import { ServicesContent } from './ServicesContent'

export function ServicesSidebar() {
  return (
    <div className='sidebar bg-cencert-bg-gray max-w-sm'>
      <ServicesContent
        showTitle={true}
        containerClassName='space-y-6'
        serviceCardContainerClassName='bg-white'
      />
    </div>
  )
}
